var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "journey-comment" }, [
    _c("div", { staticClass: "comment-header" }, [
      _c("div", { staticClass: "comment-created-by" }, [
        !_vm.isSeen
          ? _c(
              "div",
              { staticClass: "position-relative" },
              [
                _c("has-unseen-comments-marker", {
                  staticClass: "editable-comment-marker"
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(
          "\n            \n            " + _vm._s(_vm.createdBy) + "\n        "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "comment-created-date" }, [
        _vm._v(_vm._s(_vm.createdDate))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "comment-created-time" }, [
        _vm._v(_vm._s(_vm.createdTime))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "comment-actions" },
        [
          _vm.displayActions
            ? _c("div", { staticClass: "comment-action-buttons" }, [
                _c("i", {
                  staticClass: "fa fa-pencil mdb-icon-btn edit",
                  on: {
                    click: function($event) {
                      _vm.displayEditor = true
                    }
                  }
                })
              ])
            : _vm.isCommentPublishing
            ? _c("loader")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.subType
        ? _c("span", { staticClass: "comment-sub-type" }, [
            _vm._v(_vm._s(_vm.subType))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "comment-body" },
      [
        _vm.displayEditor
          ? [
              _c("comment-editor", {
                staticClass: "comment-editor",
                model: {
                  value: _vm.updatedContent,
                  callback: function($$v) {
                    _vm.updatedContent = $$v
                  },
                  expression: "updatedContent"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "comment-editor-controls" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-secondary",
                    on: { click: _vm.cancelEdit }
                  },
                  [_vm._v(_vm._s(_vm.resource("Button_Cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    on: { click: _vm.updateComment }
                  },
                  [_vm._v(_vm._s(_vm.resource("Button_Save")))]
                )
              ])
            ]
          : _c("span", [
              _vm._v("\n            " + _vm._s(_vm.content) + "\n        ")
            ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }